import { defineStore } from 'pinia';
import { useListMappingProfiles } from '../api/listMappingProfiles';
import { useMappingProfileStore } from 'shared/products/mapping/stores/mappingProfileStore';

export const useRefreshMappingProfileStore = defineStore('refresh-mapping-profiles', () => {
  const listMappingProfiles = useListMappingProfiles();
  const store = useMappingProfileStore();

  async function initialize() {
    const response = await listMappingProfiles.execute();
    if (!response.ok) return;

    store.merge(response.mappingProfiles);
  }

  return {
    initialize,
  };
});
